<template>
  <div class="main">
    <TopBar />
    <div class="app-main">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="key" />
      </transition>
    </div>
    <Foot v-show="key != '/after'" />
  </div>
</template>

<script>
import TopBar from './components/TopBar.vue'
import Foot from './components/Foot.vue'

export default {
  name: 'Layout',
  components: {
    TopBar,
    Foot,
  },
  computed: {
    key() {
      window.scrollTo({
        top: 0,
        behavior: 'auto', // 平滑滚动
      })
      return this.$route.path
    },
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.app-main {
  min-height: calc(100vh - 122px);
}
/* fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}</style>
